// import { useNavigate } from 'react-router-dom';
import { Form, Row } from 'antd';
import classNames from 'classnames/bind';
import OtpInput from 'react-otp-input';
import styles from './FormCreatePassword.module.scss';

const cx = classNames.bind(styles);

const CreatePasswordModal = ({ onFinishCreatePassword, numPhone, password, onChangePassword, errPass }) => {
    return (
        <Form onFinish={onFinishCreatePassword}>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Create a password
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    Enter login password for phone number <span> {numPhone}</span> Use for next login
                </Row>
            </Form.Item>
            <Form.Item name="password" style={{ marginTop: '30px' }}>
                <Row justify="center">
                    <OtpInput
                        name="password"
                        value={password}
                        shouldAutoFocus={true}
                        onChange={onChangePassword}
                        numInputs={6}
                        className={cx('otp_login')}
                        isInputNum={true}
                        isInputSecure={true}
                    />
                </Row>
                <Row className={cx('err')}>{errPass}</Row>
            </Form.Item>

            <Form.Item style={{ marginTop: '30px' }}>
                <button htmlType="submit" className={cx('btn_login')}>
                    Confirm
                </button>
            </Form.Item>
        </Form>
    );
};

export default CreatePasswordModal;
